<template>
  <b-navbar :shadow="true">
    <template slot="start">
      <template v-for="item in activeNavbar.navbar">
        <b-navbar-dropdown v-if="item.children.length > 0 && HasGroup(item.requiredGroups)" :label="item.label" :key="item.label">
          <template v-for="childItem in item.children">
            <b-navbar-item v-if="HasGroup(childItem.requiredGroups)" :key="childItem.label" tag="router-link" :to="{ name: activeNavbar.url + '-' + childItem.route }">{{
              childItem.label
            }}</b-navbar-item>
          </template>
        </b-navbar-dropdown>
        <b-navbar-item v-else-if="HasGroup(item.requiredGroups)" :key="activeNavbar.url + '-' + item.label" tag="router-link" :to="{ name: activeNavbar.url + '-' + item.route }">{{
          item.label
        }}</b-navbar-item>
      </template>
    </template>
  </b-navbar>
</template>

<script>
export default {
  name: "Navbar",
  methods: {
    HasGroup: function (groups = []) {
      if (!(this.$route && this.$route.params && this.$route.params.groups)) return false;
      for (const group of groups) {
        if (this.$route.params.groups.includes(group)) return true;
      }

      return false;
    },
    logout: function () {
      this.$cognitoAuth.logout();
      this.$router.push("/login");
    },
  },
  computed: {
    activeNavbar() {
      return this.$store.getters.activeSite;
    },
  },
};
</script>

<style scoped>
.navbar {
  position: relative;
}
</style>
